
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PendingParticipant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PendingParticipant"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customerDefinedId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"siteId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cohortId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subgroupId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":145}};
    doc.loc.source = {"body":"fragment PendingParticipant on PendingParticipant {\n  id\n  customerDefinedId\n  siteId\n  cohortId\n  subgroupId\n  status\n  createdAt\n  updatedAt\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
